export const URL = {
	acceptItemByApprovalUnit: 'assets/rent-requests/card/items/accept',
	acceptRequest: 'assets/rent-requests/card/',
	acquiredAssets: 'assets/rent-requests/rented/filter',
	addCustomPolygon: 'polygons/add',
	addNewAssetToExistedRequest: '/assets/rent-requests/card/items/propose/asset',
	addSiteAndLink: '/add-site-and-link',
	addUser: 'users/create',
	addUserAsPO: 'users/create-as-po',
	alarmActiveFlexidas: '/alarms/flexidas/active',
	alarmActiveFlexidasByAlarmId: '/alarms/flexidas/active/by-alarm-id',
	alarmActiveOran: '/alarms/ran',
	alarmActiveOranGroups: '/alarms/ran/groups',
	alarmActiveOranModuleNames: '/alarms/ran/module-names',
	alarmActiveOranSeverities: '/alarms/ran/severities',
	alarmActiveOranAlarmIds: '/alarms/ran/alarm-ids',
	alarmActiveOranApplicabilities: '/alarms/ran/applicabilities',
	alarmActiveOranStatuses: '/alarms/ran/statuses',
	alarmActiveOranMiddlewares: '/alarms/ran/middlewares',
	alarmActiveOranNetworkElements: '/alarms/ran/network-elements',
	alarmActiveOranClearedBy: '/alarms/ran/cleared-by',
	alarmActiveOranAcknowledgedBy: '/alarms/ran/acknowledge-by',
	alarmHistory: '/alarms/sequence-history',
	alarmHistoryFlexidas: '/alarms/flexidas/history',
	alarmManagementAddNoVesRule: '/alarms/awtg-ran/no-ves-event/add-rule',
	alarmManagementNoVesEvent: '/alarms/awtg-ran/no-ves-event/',
	alarmManagementNoVesNetworkElements: '/alarms/awtg-ran/no-ves-event/network-elements-for-create',
	alarmManagementNoFileNetworkElements: '/alarms/awtg-ran/no-file/network-elements-for-create',
	alarmManagementOranRoles: '/alarms/ran/static/user-groups',
	alarmManagementComplaint: '/alarms/ran/settings/filter',
	alarmManagementStaticOran: '/alarms/ran/static',
	alarmManagementStaticOranAcknowledgedBy: '/alarms/ran/static/acknowledge-by',
	alarmManagementStaticOranClearedBy: '/alarms/ran/static/cleared-by',
	alarmManagementStaticOranMiddlewares: '/alarms/ran/static/middlewares',
	alarmManagementStaticOranNetworkElements: '/alarms/ran/static/network-elements',
	alarmManagementTable: '/alarms',
	alarmManagementTableFlexidas: '/alarms/flexidas',
	alarmManagementTableOran: '/alarms/awtg-ran',
	alarmManagementTableBenetel: '/alarms/benetel',
	alarmManagementBenetelExport: '/alarms/benetel/export',
	alarmManagementBenetelNoVesEvent: '/alarms/benetel/no-ves-event',
	alarmManagementBenetelNoVesAddRule: '/alarms/benetel/no-ves-event/add-rule',
	alarmManagementBenetelNoVesNetworkElements: '/alarms/benetel/no-ves-event/network-elements-for-create',
	alarmManagementNoFile: '/alarms/awtg-ran/no-file/',
	alarmManagementNoFileAddRule: '/alarms/awtg-ran/no-file/add-rule',
	alarmBenetelStaticAlarmIds: '/alarms/awtg-ran/static/alarm-ids',
	alarmAwtgRanStaticAlarmIds: '/alarms/awtg-ran/static/alarm-ids',
	alarmNodeTypes: '/alarms/flexidas/static/node-types',
	alarmOranExport: '/alarms/ran/export-active',
	alarmOranHistoryExport: '/alarms/ran/export-history',
	alarms: '/alarms',
	alarmsVendors: '/alarms/static/vendors',
	alarmUsers: '/alarms/static/users',
	allCellsForSectors: '/sites/all-cells-for-sectors',
	allNotifications: 'notifications',
	allOoklaMeasurements: '/measurement/ookla/all',
	allOperatorsForOokla: '/measurement/ookla/operators/all',
	alreadyRentedDates: `assets/rent-requests/card/`,
	antennaModels: '/sites/dropdown/generic/antenna-models',
	approvalUnit: 'approval/unit',
	approvalUnitsOptions: '/approval/unit/attached/dropdown/create/units',
	approvalUnitUsers: 'dropdown/users',
	approvalUsersOptions: '/approval/unit/dropdown/create/users',
	assetAccessAvailability: 'update/asset-site-access-availability',
	assetAccess: 'asset-access',
	assetAccessRestricted: 'asset-access/restricted',
	assetAccessRestrictedEnable: 'asset-access/restricted/enable',
	assetAccessRestrictedDisable: 'asset-access/restricted/disable',
	assetAccessVisibilityModes: 'ao-visibility-modes',
	assetAccessTypes: 'asset-access-types',
	assetAccessResultingTypes: 'resulting-access-types',
	assetCart: 'assets/cart',
	assetCartRequest: 'assets/cart/filter',
	assetCartRequestCount: 'assets/cart/size',
	assetCartRequestDropdowns: 'assets/cart/filter/dropdowns',
	assetCreate: 'asset/management/create',
	assetDashboardStatus: 'dashboard/asset',
	assetGroupShowHide: 'asset/management/group/show-hide',
	assetHistoryProfile: 'asset/logs',
	assetManagement: 'asset/management',
	assetManagementCommonValues: 'asset/management/group/common-values',
	assetProfileIncomingRequests: 'assets/rent-requests/of-chosen-asset/filter/ao',
	assetProfileOutgoingRequests: 'assets/rent-requests/of-chosen-asset/filter/mno',
	assetSampleUrl: 'asset/import/get-sample-url',
	assetsFilter: 'assets/filter',
	assetsIsVisibleShowHide: 'asset/management/group/show-hide/is-visible',
	assetSiteAvailability: 'update/asset-site-availability-status',
	assetSpecialImplementationIssues: 'update/special-implementation-issues',
	assetsRented: 'asset/management/find/rented',
	assetsRentRequests: 'assets/rent-requests',
	assetsRewriteLinkedSitesCoordinates: 'assets/sites/rewrite-site-coordinates-to-asset/already-linked',
	assetsRewriteSiteCoordinates: 'assets/sites/rewrite-site-coordinates-to-asset',
	assetsSiteLink: 'assets/sites/link-site',
	assetsSites: 'assets/sites/',
	assetsSitesCheckAlreadyLinked: 'assets/sites/check-coordinates/already-linked',
	assetsSitesCheckCoordinates: 'assets/sites/check-coordinates',
	assetsSitesUnlink: 'assets/sites/unlink-sites',
	assetsSubTypeManagement: 'asset-sub-type/management',
	assetsTable: 'asset/management/filter',
	assetsTypeManagement: 'asset-type/management',
	assetSubTypes: 'asset/management/all-subtypes',
	assetTypes: 'asset/management/dropdown/types-subtypes',
	assetVisibility: 'asset-visibility',
	assetVisibilityRestricted: 'asset-visibility/restricted',
	assetVisibilityRestrictedEnable: 'asset-visibility/restricted/enable',
	assetVisibilityRestrictedDisable: 'asset-visibility/restricted/disable',
	assetVisibilityTypes: 'asset-visibility-types',
	attachedApprovalUnit: 'approval/unit/attached',
	attachedApprovalUnitUsers: 'dropdown/units',
	attachedTypesSubTypes: 'dropdown/types-subtypes',
	backhaulAccessibility: 'update/backhaul-accessibility-status',
	bands4GFdd: '/sites/dropdown/generic/4g-fdd-bands',
	bands4GTdd: '/sites/dropdown/generic/4g-tdd-bands',
	bands5G: '/sites/dropdown/generic/5g-bands',
	block: 'block',
	boroughs: 'boroughs',
	boroughsSummary: 'boroughs/summary',
	cacheReplicationAssets: '/assets/cache-replication',
	cacheReplicationSites: '/sites/cache-replication',
	card: '/card',
	cart: 'assets/cart',
	cell4GFdd: 'cells/4g/fdd',
	cell4GTdd: 'cells/4g/tdd',
	cell5G: 'cells/5g',
	cellsUsedBands: 'sites/cells-used-bands',
	changePassword: 'users/profile/change-password',
	chartsKpi: '/kpis/charts',
	chartsKpiProgress: '/kpis/progresses',
	chartsKpiRun: '/kpis/charts-run',
	checkAssetInformation: 'asset/management/check-assetid',
	checkEmailAsPo: 'users/check-email-as-po',
	checkEmail: 'users/check-email',
	checkPassword: 'users/profile/check-password',
	checkPhoneNumber: 'users/profile/check-phone-number',
	checkPolygonName: 'polygons/check',
	checkValidPassword: 'users/profile/check-valid-password',
	clean: '/clean',
	cmModuleVendors: '/cm/static/vendors',
	commissionSettings: 'settings/commission',
	countriesAll: 'countries/all',
	categoriesAll: '/organization/categories/all',
	configurationComparison: 'configuration-comparison',
	configurationComparisonTechnologies: '/configuration-comparison/technologies',
	configurationComparisonVendors: '/configuration-comparison/vendors',
	configurationConsistency: '/configuration-consistency',
	configurationConsistencyAWTGRan: '/configuration-consistency/awtg-ran',
	configurationConsistencyConfigTypes: '/configuration-consistency/types',
	configurationConsistencyDates: '/configuration-consistency/dates',
	configurationConsistencyDatesOptions: '/configuration-consistency/options-dates',
	configurationConsistencyNodes: '/configuration-consistency/nodes',
	configurationConsistencyNodeTypes: '/configuration-consistency/node-types',
	configurationConsistencyParameters: '/configuration-consistency-parameters/',
	configurationConsistencyParametersAWTGRan: '/configuration-consistency-parameters/awtg-ran',
	configurationConsistencyParametersProgresses: '/configuration-consistency-parameters/progresses',
	configurationConsistencyTechnologies: '/configuration-consistency/technologies',
	configurationConsistencyVendors: '/configuration-consistency/vendors',
	configurationConsistencyVersions: '/configuration-consistency/versions',
	configurationHistoryConfigTypes: '/configuration-history/types',
	configurationHistoryDateOptions: '/configuration-history/options-dates',
	configurationHistoryDates: '/configuration-history/dates',
	configurationHistoryNodes: '/configuration-history/nodes',
	configurationHistoryNodeTypes: '/configuration-history/node-types',
	configurationHistorySiteIds: '/configuration-history/site-ids',
	configurationHistoryTechnologies: '/configuration-history/technologies',
	configurationHistoryVendors: '/configuration-history/vendors',
	configurationHistoryVersions: '/configuration-history/versions',
	historyCheckAwtgRanConfigTypes: '/history-check/awtg-ran/options/config-types',
	historyCheckAwtgRanNetworkElements: '/history-check/awtg-ran/options/network-elements',
	historyCheckAwtgRanDates: '/history-check/awtg-ran/options/dates',
	historyCheckAwtgRanFetch: '/history-check/awtg-ran/fetch',
	historyCheckAwtgRanProgresses: '/history-check/awtg-ran/progresses',
	historyCheckAwtgRanRun: '/history-check/awtg-ran/run',
	historyCheckAwtgRanManagedObjectsIds: '/history-check/awtg-ran/parameters',
	historyCheckAwtgRanManagedObjectsNames: '/history-check/awtg-ran/parameters',
	historyCheckAwtgRanNetworkElementNames: '/history-check/awtg-ran/parameters',
	historyCheckAwtgRanDetails: '/history-check/awtg-ran/parameters/details',
	configurationTemplates: '/configuration-template',
	contactPersons: 'users/contact-persons',
	contractRequest: 'assets/rent-requests/card/',
	correlationKpi: '/kpis/correlation',
	createAssetUploadUrl: 'asset/import/create-upload-url',
	createKpiAlert: '/kpis/alerts',
	createPolygonUploadUrl: 'polygons/import/create-upload-url',
	createSitesUploadUrl: 'create-upload-url',
	createTreePreset: 'configuration-comparison/trees/preset/create',
	createUploadBrandingLogoUrl: 'organizations/settings/branding/create-upload-url',
	createUploadLogoUrl: '/organizations/logo/create-upload-url',
	createUploadUrlAttachment: 'asset/management/add-attachment',
	crowdCellConfig: '/get-crowd-cell-config',
	crowdCellDatesExist: '/get-dates-exist',
	crowdCells: 'crowd-cells',
	currentUser: 'users/user',
	dashboardAssetSummary: 'dashboard/asset/summary',
	dashboardAssetType: 'dashboard/asset-type',
	dashboardRentSummary: 'dashboard/rent/summary',
	dashboardRequestStatusSummary: 'dashboard/request-status/summary',
	dasNames: '/alarms/flexidas/static/das-names',
	datesCcModule: '/configuration-comparison/dates',
	datesExistsForOokla: '/measurement/ookla/get-dates-exist',
	declineItemByApprovalUnit: 'assets/rent-requests/card/items/decline',
	declineRequest: '/assets/rent-requests/card',
	deleteAsset: 'users/delete',
	deleteAssets: 'asset/management/delete',
	deleteCustomPolygons: 'polygons/delete-many',
	deleteOrganisations: 'organizations/delete',
	deleteSites: '/sites/delete',
	deleteTreePreset: 'configuration-comparison/trees/preset',
	deleteUsers: 'users/delete',
	deleteOneUserAsPo: 'delete-one-as-po',
	deleteUsersOrganisationLevel: 'users/delete-organization-user',
	deleteUsersAsPoUserTable: 'users/delete-as-po',
	disable2Fa: 'users/profile/disable2fa',
	doneRequest: 'assets/rent-requests/card/',
	downloadCrowdCellConfig: '/download-crowd-cell-config',
	downloadHistory: '/file-download-history',
	downloadURL: '/file/download-url',
	dynamicDates: '/kpis/presets/dynamic-dates',
	editUser: 'users/update',
	editUserProfile: 'users/profile/update',
	errorCodeEdit: 'error',
	errors: 'error/all',
	errorsFilter: 'error/filter',
	export4GFddCells: 'cells/export-4g-fdd',
	export4GTddCells: 'cells/export-4g-tdd',
	export5GCells: 'cells/export-5g',
	exportAcquiredAssets: 'assets/rent-requests/export-rented-assets-info',
	exportActiveAlarmsFlexidas: 'alarms/flexidas/active/export',
	exportAlarmHistory: '/alarms/sequence-history/export',
	exportAlarmHistoryFlexidas: '/alarms/flexidas/history/export',
	exportAllCells: 'nokia/cells/export-all',
	exportAllCellsLimenet: 'limenet/cells/export-all',
	exportAssetFile: 'assets/export/export-assets-info',
	exportAssetInfoPolygon: 'assets/export/export-assets-info/polygon',
	exportAssetRules: 'assets/export/rules/get',
	exportAssetRulesUpdate: 'assets/export/rules/update',
	exportBranch: 'configuration-comparison/branch/export',
	exportBranches: 'configuration-comparison/branches/export',
	exportCompareKpi: '/kpis/export/compare',
	exportCorrelateKpi: '/kpis/export/correlate',
	exportHistoryCheckBranchDetails: 'configuration-history/branch/export',
	exportHistoryCheckBranches: 'configuration-history/branches/export',
	exportHistoryCheckParameter: 'configuration-history/branch/parameter/export',
	exportHistoryCheckAwtgRanBranches: 'history-check/awtg-ran/export',
	exportHistoryCheckAwtgRanPath: 'history-check/awtg-ran/path/export',
	exportHistoryCheckAwtgRanPathParameter: 'history-check/awtg-ran/path/parameter/export',
	exportKpi: '/kpis/export',
	filterThresholds: 'assets/thresholds',
	findBySiteId: 'sites/find',
	findRentedAssets: 'asset/management/rented/rented-ids',
	getApprovalInfoAsAO: `/assets/rent-requests/card/items/approval-info/as-ao`,
	getApprovalInfoAsMNO: `/assets/rent-requests/card/items/approval-info/as-mno`,
	getAssetCardItems: `/assets/rent-requests/card/items`,
	getAssetListDropdown: '/asset/management/dropdown/active',
	getAssetOwners: `assets/rent-requests/asset-owners`,
	getAssetRent: '/assets/rent-requests',
	getAssetRentRequestCard: '/assets/rent-requests/card',
	getAssetsRentIncomingRequests: '/assets/rent-requests/as-ao',
	getAssetsRentOutgoingRequests: '/assets/rent-requests/as-mno',
	getAssetsRentRequestTypes: '/assets/rent-requests/types',
	getAssetsRequestStatuses: '/assets/rent-requests/statuses',
	getKPIAlerts: '/kpis/alerts',
	getKpiAlertsForRan: '/ran/kpis/alerts',
	getKpiAlertVendorsDropdown: '/kpis/alerts/static/vendors',
	getNetworkOperators: `assets/rent-requests/network-operators`,
	goldenSettings: '/golden-settings',
	goldenSettingsConfig: '/golden-settings/config',
	goldenSettingsConfigTree: '/golden-settings/config-tree',
	goldenSettingsCreateUploadUrl: '/golden-settings/import/create-upload-url',
	goldenSettingsDates: '/golden-settings/dates',
	goldenSettingsExport: '/golden-settings/export',
	goldenSettingsImport: '/golden-settings/import',
	goldenSettingsInfo: '/golden-settings/info',
	goldenSettingsOptionsDates: '/golden-settings/options-dates',
	goldenSettingsReset: '/golden-settings/reset',
	goldenSettingsSites: '/golden-settings/sites',
	goldenSettingsValidationRules: '/golden-settings/validation-rules',
	granularitiesKpiOran: '/kpis/granularities',
	groupedCounters: '/kpis/grouped-tree-counters',
	groupedKpi: 'kpis/grouped-tree-kpis',
	groups: '/alarms/static/groups',
	history2Fa: 'users/profile/get-seconds',
	historyPassword2Fa: 'users/profile/change-password2fa/get-seconds',
	importAsset: '/asset/import/',
	importAssetExecute: '/execute',
	importAssetFieldSamples: '/get-field-samples',
	importAssetFieldsMapping: '/save-fields-mapping',
	importAssetGetAllFields: '/get-all-fields',
	importAssetSaveImportRules: '/save-import-rules',
	importAssetSystemFields: 'get-system-fields',
	importPolygonExecute: '/execute',
	importPolygonFieldSamples: '/get-field-samples',
	importPolygonFieldsMapping: '/save-fields-mapping',
	importPolygons: 'polygons/import',
	importPolygonSystemFields: 'polygons/import/get-system-fields',
	importSites: '/sites/import/',
	importSitesExecute: '/execute',
	importSitesFieldSamples: '/get-field-samples',
	importSitesFieldsMapping: '/save-fields-mapping',
	importSitesGetAllFields: '/get-all-fields',
	importSitesSaveImportRules: '/save-import-rules',
	importSitesSystemFields: 'get-system-fields',
	importSitesTypes: 'import-types',
	importStatistics: '/get-statistics',
	importTypes: 'asset/import/import-types',
	kaiAssistants: 'organizations/kai-assistant',
	kaiAssistantByUser: `organizations/kai-assistant/get-by-user`,
	kpiAlertsRoles: '/kpis/alerts/static/user-groups',
	kpiAlertsUsers: '/kpis/alerts/static/users',
	kpis: '/kpis/grouped',
	kpisGroupedLineType: '/kpis/grouped-tree-kpis/line',
	kpisLineType: '/kpis/grouped/line',
	limenet: 'limenet',
	limenetCells: 'crowd-cells/limenet/cells',
	linkSite: '/link-site',
	manageAcquiredAssetsAssetOwners: 'assets/rent-requests/rented/asset-owners',
	mavenirConfig: '/configuration-file-management/mavenir',
	mavenirConfigs: '/configuration-file-management/mavenir/create-many',
	measurementNamesForOokla: '/measurement/ookla/measurement-names/all',
	middlewareSMO: 'smo-middleware',
	middlewareSMOConnectionLogs: 'smo-middleware/connection-logs',
	middlewareSMOConnectionLogsStatic: 'static/smo-middleware/connection-logs',
	middlewareSMOGet: 'smo-middleware/get',
	middlewareSMOStatuses: 'smo-middleware/statuses',
	moBranches: 'configuration-comparison/comparisons',
	moBranchesGet: 'configuration-comparison/comparisons-get',
	moBranchesProgress: 'configuration-comparison/progresses',
	moBranchesRun: 'configuration-comparison/comparisons-run',
	netconfEvents: 'network-elements/netconf-events',
	networkElements: 'network-elements',
	networkElementsConfigurations: 'configurations/network-elements',
	networkElementsConfigurationsByDate: 'configurations/network-elements/get-config-xml-data-by-date',
	networkElementsConfigurationsCandidate: 'configurations/network-elements/edit-config/candidate',
	networkElementsConfigurationsDates: 'configurations/network-elements/config-dates',
	networkElementsConfigurationsLatestConfig: 'configurations/network-elements/view-latest-configuration-xml-data',
	networkElementsConfigurationsMiddlewares: 'static/configurations/network-elements/middlewares',
	networkElementsConfigurationsStatuses: 'static/configurations/network-elements/connection-status',
	networkElementsConfigurationsTimestamps: 'configurations/network-elements/config-date-with-all-timestamps',
	networkElementsConfigurationsTypes: 'static/configurations/network-elements/types',
	networkElementsMiddleware: 'network-elements/middlewares',
	networkElementsStatusLogs: 'network-elements/status-logs',
	netWorkElementsValidationRules: 'network-elements/validation-rules',
	netWorkElementsValidationRulesFolders: 'static/configurations/network-elements/validation-rules-folders',
	nodeTypes: '/configuration-comparison/node-types',
	nokia: 'nokia',
	nokiaSites: '/sites/nokia',
	notificationsCount: 'notifications/count',
	ooklaDataFiltered: 'measurement/ookla/filter',
	operationWindowRules: 'operational-window-rules',
	organisationMapSettings: '/organization/settings/map',
	organisationProjects: '/portal/organization/projects',
	organisationProjectsAdmins: '/portal/organization/projects/admins',
	organisationProjectsCreate: '/portal/organization/projects/create',
	organisationProjectsDelete: '/portal/organization/projects/delete',
	organisationProjectsMembers: '/portal/organization/projects/members',
	organisationProjectsStatuses: '/portal/organization/projects/statuses',
	organisationProjectsWorkflows: '/portal/organization/projects/workflows',
	organisationRoles: 'organizations/role-availability',
	organisationSwitch: 'organizations/switch',
	organisationSwitchFavouriteAdd: 'organizations/switch/favourite/add',
	organisationSwitchFavouriteRemove: 'organizations/switch/favourite/remove',
	organisationTypes: '/organization/types/all',
	organizationCurrentUsers: 'organizations/current/users',
	organizationProfile: 'organizations',
	organizationProfileByUser: 'organizations/get-by-user',
	organizationsActive: 'organizations/all-active',
	organizationsAssetOwnersFilter: 'organizations/asset-owners',
	organizationsAll: 'organizations/all',
	organizationsBranding: 'organizations/settings/branding',
	organizationsBrandingCreate: 'organizations/settings/branding/create',
	organizationsBrandingList: 'organizations/settings/branding/filter',
	organizationsCheckValues: 'organizations/create/check-fields',
	organizationsCreate: 'organizations/create',
	organizationsEdit: 'organizations/update',
	organizationsEditByUser: 'organizations/update-as-owner',
	organizationSettings: 'organizations/settings',
	organizationSettingsVendors: 'organizations/settings/vendors',
	organizationsFilter: 'organizations/filter',
	organizationsUsersDropdown: 'organizations/users/dropdown',
	parameterHistory: '/parameter-history/',
	parameterHistoryBranches: '/parameter-history/history',
	parameterHistoryProgresses: '/parameter-history/progresses',
	platformOwnerProjects: '/organizations/projects',
	platformOwnerProjectsAdmins: '/organizations/projects/admins',
	platformOwnerProjectsCreate: '/organizations/projects/create',
	platformOwnerProjectsDelete: '/organizations/projects/delete',
	platformOwnerProjectsMembers: '/organizations/projects/members',
	platformOwnerProjectsStatuses: '/organizations/projects/statuses',
	platformOwnerProjectsWorkflows: '/organizations/projects/workflows',
	polygonSampleUrl: 'polygons/import/get-sample-url',
	polygonsFiltered: 'polygons/filter',
	polygonsSummary: 'summary/polygons/asset/general-summary',
	portalAvailableMilestones: '/portal/tasks/get-milestones',
	portalAvailableProjects: '/portal/projects/get-available-projects',
	portalCheckFolderName: 'portal/folders/check-unique-name',
	portalCreateFolder: 'portal/folders/create',
	portalCreateMilestone: '/portal/milestones/create',
	portalCreateTask: '/portal/tasks/create',
	portalDeleteFiles: '/portal/files/delete',
	portalAttachFiles: '/portal/files/link-milestones',
	portalDeleteMilestones: '/portal/milestones/delete',
	portalDeleteTasks: '/portal/tasks/delete',
	portalDownloadFiles: '/portal/files/download',
	portalDownloadFolders: 'portal/folders/download',
	portalFiles: 'portal/files',
	portalFilesUploadUrlAttachment: '/portal/files/create-upload-url',
	portalFilesUsers: 'portal/files/users',
	portalFilesMilestones: 'portal/files/milestones',
	portalFilesMilestonesFilter: 'portal/files/milestones-with-no-milestone',
	portalFolders: 'portal/folders',
	portalMilestones: '/portal/milestones',
	portalMilestonesAssignees: '/portal/milestones/assignees',
	portalMilestonesAssigneesFilter: '/portal/milestones/assignees-with-unassigned',
	portalMilestonesGroupedTasksToLink: '/portal/milestones/get-grouped-tasks-to-link',
	portalMilestonesStatuses: '/portal/milestones/statuses',
	portalMoveFiles: '/portal/files/move',
	portalProjectAdmins: '/portal/projects/admins',
	portalProjectMembers: '/portal/projects/members',
	portalProjects: '/portal/projects',
	portalProjectsStatuses: '/portal/projects/statuses',
	portalTasks: '/portal/tasks',
	portalTasksAssignees: '/portal/tasks/assignees',
	portalTasksAssigneesFilter: '/portal/tasks/assignees-with-unassigned',
	portalTasksLinkTypes: '/portal/tasks/link-types',
	portalTasksPriorities: '/portal/tasks/priorities',
	portalTasksStatuses: '/portal/tasks/statuses',
	portalTasksToLink: '/portal/tasks/get-tasks-to-link',
	portalTaskUploadUrlAttachment: '/portal/tasks/attachment/create-upload-url',
	portalTimeline: '/portal/timeline',
	portalTimelineAssigneesFilter: '/portal/timeline/assignees-with-unassigned',
	portalTimelineMilestonesFilter: '/portal/timeline/milestones-with-no-milestone',
	portalTimelinePriorities: '/portal/timeline/priorities',
	portalTimelineStatuses: '/portal/timeline/statuses-by-project',
	portalUploadFiles: 'portal/files/upload',
	powerSupplyAvailability: 'update/power-supply-availability-status',
	presets: '/kpis/presets',
	presetsThreshold: '/kpis/thresholds/presets',
	proposeNewDates: 'assets/rent-requests/card/items/propose/dates',
	queryAsset: 'asset/management/send-email/query-asset',
	readAllNotifications: 'notifications/read-all',
	removeAllNotifications: 'notifications/delete-all',
	rentRequestsCard: 'assets/cart',
	responsible: 'asset/management/responsible',
	revokeItemByApprovalUnit: 'assets/rent-requests/card/items/revoke',
	roles: 'users/roles',
	ruDashboard: 'network-elements/ru',
	ruDashboardFilter: 'network-elements/ru/filter',
	ruDashboardStatic: 'network-elements/ru/static',
	schemaConfig: '/configuration-data-management/mavenir',
	ruConfiguration: 'smo-middleware/cm-data/benetel/ru',
	schemaOranConfig: '/configuration-data-management/awtg-ran',
	sectors: 'sites/sectors',
	sectorsFiltered: 'sites/sectors/filter',
	selectedPresetTree: 'configuration-comparison/trees/preset',
	sendCode: 'users/profile/check-valid2fa',
	sendCodeForPassword: 'users/profile/change-password2fa',
	sendCodeToNumber: 'users/profile/process2fa',
	sendCodeToNumberForPassword: 'users/profile/change-password2fa/process2fa',
	sendRequestToAO: 'assets/rent-requests/card/',
	settingsKpi: '/kpis/settings',
	severities: '/alarms/static/severities',
	severitiesFlexidas: '/alarms/flexidas/static/severities',
	siteId: '/generate/site-id',
	siteIdsOptions: '/configuration-comparison/site-ids',
	siteProfile: '/site-profile',
	sites: '/sites',
	sitesFilter: '/sites/filter',
	sitesKpi: '/kpis/sites',
	sitesKpiOran: '/kpis/sites/grouped',
	sitesSampleUrl: 'get-sample-url',
	siteTypes: '/sites/dropdown/generic/site-types',
	startupPolygon: 'polygons/startup',
	swapUsers: 'users/swap-user',
	technologies: '/sites/dropdown/generic/technologies',
	technologiesForOokla: '/measurement/ookla/technologies/all',
	technology: 'technology',
	thresholds: '/kpis/thresholds',
	thresholdTechnologies: '/kpis/thresholds/technologies',
	thresholdVendors: '/kpis/thresholds/vendors',
	timezonesOptions: 'organizations/timezones',
	treeCcModule: '/configuration-comparison/trees/merge',
	treePresets: 'configuration-comparison/trees/presets',
	unblock: 'unblock',
	unlinkedCrowdCells: '/unlinked-crowdcells',
	unlinkedSites: '/unlinked-sites',
	unlinkedSitesForLink: '/sites-for-link',
	unlinkSite: '/unlink-site',
	updateCustomPolygon: 'polygons/update',
	updateTreePreset: 'configuration-comparison/trees/preset/update',
	updateUserAsPo: 'update-as-po',
	userActions: 'user/actions/',
	userActionsFilter: 'user/actions/filter',
	userBlock: 'users/block',
	userGroups: '/alarms/static/user-groups',
	userProfile: 'user-profile',
	userProfileAsPo: 'get-profile-as-po',
	userProfileInfo: 'users/profile/get-info',
	users: 'users/filter',
	usersStatusesAsPo: 'users/statuses',
	usersOrganizationsAsPo: 'users/organizations',
	usersAsPo: 'users/filter-as-po',
	userUnblock: 'users/unblock',
	vendors: '/sites/dropdown/generic/vendors',
	vendorsKpi: '/kpis/vendors',
	vesEvents: '/middleware/ves',
	vesEventsDropdownValues: '/middleware/ves/static/dropdown-data',
	vesExport: '/middleware/ves/export',
	websocketNotification: 'notification',
	websocketURL: '/v1/ws/secured/user',
	zones: '/sites/dropdown/generic/zones',
};
